<template>
  <div class="search">
    <van-nav-bar
      left-arrow
      @click-left="onClickLeft">
      <template #title>
        <div class="search-cont">
          <form action="/">
            <van-search
              show-action
              placeholder="搜索艺术家，机构，作品，风格等"
              @search="onSearch"
              @cancel="onCancel">
              <template #action>
                <div @click="onSearch">搜索</div>
              </template>
            </van-search>
          </form>
        </div>
      </template>
    </van-nav-bar>
    <div class="search-condition">
      <ul class="condition">
        <li class="select">搜职位</li>
        <li @click="company">搜公司</li>
      </ul>
      <ul class="pop-select">
        <li @click="showPickerPlace">{{place}}</li>
        <li>筛选</li>
      </ul>
    </div>
    <ul class="job-list">
      <li v-for="item in jobs" :key="item.index">
        <div class="detail-info">
          <div class="info-header">
            <h3>{{item.title}} <small>急</small> </h3>
            <span>{{item.wages}}</span>
          </div>
          <ul class="conditionList">
            <li v-for="condition in item.conditionList" :key="condition.index">
              {{condition.detail}}
            </li>
          </ul>
          <ul class="feature">
            <li v-for="feature in item.featurelist" :key="feature.index">
              {{feature.detail}}
            </li>
          </ul>
          <div class="contact">
            <div class="person">
              <img :src='item.person'>
              <span>{{item.name}}</span>
            </div>
            <div class="place">
              {{item.place}}
            </div>
          </div>
        </div>
      </li>
    </ul>
    <van-popup v-model="showPlace" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="pickerPlace = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'searchJob',
  data() {
    return {
      showPlace: false,
      place: '地点',
      columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
      jobs: [
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          person: require('@/assets/img/user.png'),
          name: '刘经理·人事',
          place: '嘉定新城',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          person: require('@/assets/img/user.png'),
          name: '刘经理·人事',
          place: '嘉定新城',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          person: require('@/assets/img/user.png'),
          name: '刘经理·人事',
          place: '嘉定新城',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          person: require('@/assets/img/user.png'),
          name: '刘经理·人事',
          place: '嘉定新城',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        }
      ]
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onSearch() {
      this.$router.push({ path: '/result' })
    },
    onCancel() {

    },
    onConfirm(value) {
      this.place = value
      this.showPlace = false
    },
    company() {
      this.$router.push({ path: '/searchCompany' })
    },
    showPickerPlace() {
      this.showPlace = true
    }
  }
}
</script>

<style lang="less" scoped>
  .search-condition{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin:10px 16px 20px;
    ul{
      display: flex;
      align-items: center;
      li{
        color:#B7BABF;
        font-size: 12px;
        padding:6px 12px;
      }
      &.condition{
        .select{
          background: #F5F2EF;
          color:#2E3133;
          border-radius: 50px;
        }
      }
      &.pop-select{
        li{
          position: relative;
          &:after{
            content: '\e629';
            position: absolute;
            right:-6px;
            top:8px;
            font-family: van-icon;
          }
        }
      }
    }
  }
  .job-list{
    margin-left: 0;
    margin-right: 0;
    &>li{
      padding:6px 16px;
      border-bottom: 8px solid #F7F7F7;
      &:last-child{
        border-bottom: 0;
      }
    }
  }
</style>
